import {configRecaptcha} from './config'
import eventBus from './eventBus'

export default class Recaptcha {
  /* global grecaptcha */
  static instance = null
  initiatedV3 = false
  initiatedV2 = false
  avaliableVersions = [2, 3]
  widget = null
  static getInstance () {
    if (this.instance === null) {
      this.instance = new this()
    }
    return this.instance
  }

  async initiateCaptcha (version) {
    return new Promise((resolve, reject) => {
      if (this['initiatedV' + version] === true) {
        resolve()
      } else {
        let script = document.createElement('script')
        if (version === 3) {
          script.src = configRecaptcha.url + '?render=' + configRecaptcha.siteKeyV3
        } else {
          script.src = configRecaptcha.url + '?render=explicit'
        }
        script.addEventListener('load', async () => {
          this['initiatedV' + version] = true
          resolve()
        })
        document.getElementsByTagName('head')[0].appendChild(script)
      }
    })
  }

  async getRecaptchaToken (version) {
    return new Promise(async (resolve, reject) => {
      if (this.avaliableVersions.indexOf(version) === -1) {
        reject(new Error('Zahtevana verzija ni podprta'))
      } else {
        if (this['initiatedV' + version] === false) {
          await this.initiateCaptcha(version)
        }
        switch (version) {
          case 3:
            grecaptcha.ready(() => {
              grecaptcha.execute(configRecaptcha.siteKeyV3, {action: 'submit'}).then(function (token) {
                resolve(token)
              })
            })
            break
          case 2:
            eventBus.$emit('KRITICNI_PROCES_POPUP', true)
            grecaptcha.ready(async () => {
              let element = document.getElementById('recaptchaWidgetRenderer')
              let options = {
                sitekey: configRecaptcha.siteKeyV2,
                callback: (token) => {
                  eventBus.$emit('KRITICNI_PROCES_POPUP', false)
                  resolve(token)
                }
              }
              if (this.widget === null) {
                this.widget = grecaptcha.render(element, options)
              } else {
                grecaptcha.reset(this.widget)
              }
            })
            break
          default: reject(new Error('Nepodprta verzija'))
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Recaptcha.js